import { useMemo } from 'react';
export function useFileUploaderSize(size, _ref) {
  var small = _ref.small,
    medium = _ref.medium,
    large = _ref.large;
  return useMemo(function () {
    switch (size) {
      case 'large':
        return large;
      case 'medium':
        return medium;
      case 'small':
        return small;
      default:
        return small;
    }
  }, [size]);
}